/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://bpwno5y2kbddri7k4xpz33byd4.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2c4rfs7l3vcofg6l7nujpzgodm",
    "aws_cognito_identity_pool_id": "ap-south-1:cc2929da-f652-4f7e-b6cb-350a948c0437",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_opQe4kyUJ",
    "aws_user_pools_web_client_id": "3lo4lcti41avjbhig0dnqh5e6v",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "drivecaro5f9cd55ff34f4aae814130bcf062539a121408-dev",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
